type Prop = {
  numberOfCards: number;
};

const buildVehicleCardList = (numberOfCards: number) => {
  const cardList = [];
  for (let i = 0; i < numberOfCards; i += 1) {
    cardList.push(
      <div key={i} className="flex flex-col gap-1 h-96 lg:h-96">
        <div className="h-2/3 bg-gray-100 rounded-lg animate-pulse"> </div>
        <div className="h-1/3 grid  gap-y-1 gap-x-1">
          <div
            className="bg-gray-100 rounded animate-pulse"
            style={{
              animationFillMode: "backwards",
              animationDelay: "150ms",
            }}
          >
            {" "}
          </div>
          <div
            className="bg-gray-100 rounded animate-pulse"
            style={{
              animationFillMode: "backwards",
              animationDelay: "300ms",
            }}
          >
            {" "}
          </div>
          <div
            className="flex flex-row gap-1 animate-pulse"
            style={{
              animationFillMode: "backwards",
              animationDelay: "450ms",
            }}
          >
            <div className="w-1/2 bg-gray-100 rounded"> </div>
            <div className="w-1/2 bg-gray-100 rounded"> </div>
          </div>
          <div
            className="bg-gray-100 rounded animate-pulse"
            style={{
              animationFillMode: "backwards",
              animationDelay: "600ms",
            }}
          >
            {" "}
          </div>
        </div>
      </div>
    );
  }

  return cardList;
};

const VehicleCardListSkeleton = ({ numberOfCards }: Prop) => {
  return (
    <div className="mt-6 w-full grid grid-flow-row grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5 xl:gap-x-8">
      {buildVehicleCardList(numberOfCards)}
    </div>
  );
};

export default VehicleCardListSkeleton;
